import { PosServiceProvider } from './../../providers/pos-service/pos-service';
import { AuthProvider } from './../../providers/auth/auth';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';

@IonicPage()
@Component({
  selector: 'page-pos-transaction',
  templateUrl: 'pos-transaction.html',
})
export class PosTransactionPage {
  activeTab: string = 'running';

  // Running
  dashRunning: {};
  dashTimer: {};
  totalRecRunning = 0;
  totalAmtRunning = 0;
  use_timer_schedule = false;
  server_date = new Date();

  // Paid
  dashPaid: {};
  totalRecPaid = 0;
  totalAmtPaid = 0;

  // Canceled
  dashCanceled: {};
  totalRecCanceled = 0;
  totalAmtCanceled = 0;

  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private posservice: PosServiceProvider, private loadingCtrl: LoadingController, private global: GlobalProvider) {
      let info = this.auth.getUserInfo();
      this.name = info.name;
      this.username = info.username;
      this.serverlocation = info.serverlocation;
      this.userid = info.userid;
      this.token = info.token;
      if (this.global.use_timer_schedule == 1) {
        this.use_timer_schedule = true;
      }
      this.loadRunning();
      this.getDateServer();

      if (this.use_timer_schedule) {
        setInterval(() => {
          this.calculateTimer();
        }, 30000);
      }
  }

  switchTab(tab: string) {
    this.activeTab = tab;
    if (tab === 'running' && !this.dashRunning && !this.dashTimer) {
      this.loadRunning();
    } else if (tab === 'paid' && !this.dashPaid) {
      this.loadPaid();
    } else if (tab === 'canceled' && !this.dashCanceled) {
      this.loadCanceled();
    }
  }

  // ===== Running =====
  public calculateTimer() {
    this.getDateServer();
    let m = 0;
    for (let key in this.dashTimer) {
      let j = new Date(this.dashTimer[m].onTimerEnd);
      let diffInMilliSecs: number = (new Date(j).getTime() - new Date(this.server_date).getTime());
      let diffinMins: number = diffInMilliSecs / 1000 / 60;
      let hours = Math.floor(diffinMins / 60);
      let minutes = Math.floor(diffinMins % 60);
      if (this.dashTimer[m].Remaining !== "00:00") {
        this.dashTimer[m].Remaining = ("00" + hours).slice(-2) + ':' + ("00" + minutes).slice(-2);
      }
      m++;
    }
  }

  public getDateServer() {
    this.posservice.getDateServer(this.userid, this.token, this.serverlocation)
      .then(data => {
        this.server_date = data['message'];
      });
  }

  public loadRunning() {
    this.showLoading();
    if (this.use_timer_schedule) {
      this.posservice.loadPOSRunningTimer(this.userid, this.token, this.serverlocation)
        .then(data => {
          this.dashTimer = data;
          let myArr = [];
          myArr.push(this.dashTimer);
          let sortedBuilds = myArr.sort((n1, n2) => {
            return this.naturalCompare(n1.name, n2.name);
          });
          this.dashTimer = sortedBuilds[0];
          this.totalAmtRunning = this.totalamttimer();
          this.loading.dismiss();
        });
    } else {
      this.posservice.loadPOSRunning(this.userid, this.token, this.serverlocation, this.global.ICNO)
        .then(data => {
          this.dashRunning = data;
          this.totalAmtRunning = this.totalamtRunning();
          this.loading.dismiss();
        });
    }
  }

  naturalCompare(a, b) {
    var ax = [], bx = [];
    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]); });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]); });
    while (ax.length && bx.length) {
      var an = ax.shift();
      var bn = bx.shift();
      var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
      if (nn) return nn;
    }
    return ax.length - bx.length;
  }

  totalamtRunning() {
    let total = 0;
    let m = 0;
    for (let key in this.dashRunning) {
      let j = this.dashRunning[m].TotalNet;
      total += Number(j.replace(/,/g, ''));
      m++;
    }
    this.totalRecRunning = m;
    return total;
  }

  totalamttimer() {
    let total = 0;
    let m = 0;
    for (let key in this.dashTimer) {
      let j = this.dashTimer[m].Total;
      total += Number(j.replace(/,/g, ''));
      m++;
    }
    this.totalRecRunning = m;
    return total;
  }

  // ===== Paid =====
  public loadPaid() {
    this.showLoading();
    this.posservice.loadPOSPaid(this.userid, this.token, this.serverlocation, this.global.ICNO)
      .then(data => {
        this.dashPaid = data;
        this.totalAmtPaid = this.totalamtPaid();
        this.loading.dismiss();
      });
  }

  totalamtPaid() {
    let total = 0;
    let m = 0;
    for (let key in this.dashPaid) {
      let j = this.dashPaid[m].TotalNet;
      total += Number(j.replace(/,/g, ''));
      m++;
    }
    this.totalRecPaid = m;
    return total;
  }

  // ===== Canceled =====
  public loadCanceled() {
    this.showLoading();
    this.posservice.loadPOSCanceled(this.userid, this.token, this.serverlocation, this.global.ICNO)
      .then(data => {
        this.dashCanceled = data;
        this.totalAmtCanceled = this.totalamtCanceled();
        this.loading.dismiss();
      });
  }

  totalamtCanceled() {
    let total = 0;
    let m = 0;
    for (let key in this.dashCanceled) {
      let j = this.dashCanceled[m].TotalNet;
      total += Number(j.replace(/,/g, ''));
      m++;
    }
    this.totalRecCanceled = m;
    return total;
  }

  // ===== Common =====
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  doRefresh(refresher) {
    this.getDateServer();
    if (this.activeTab === 'running') {
      this.dashRunning = null;
      this.dashTimer = null;
      this.loadRunning();
    } else if (this.activeTab === 'paid') {
      this.dashPaid = null;
      this.loadPaid();
    } else if (this.activeTab === 'canceled') {
      this.dashCanceled = null;
      this.loadCanceled();
    }
    setTimeout(() => {
      refresher.complete();
    }, 2000);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PosTransactionPage');
  }

  ionViewDidEnter() {
    this.getDateServer();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pos-transaction/pos-transaction.ts